import { CurrencyEnum } from '@shared/enums/currency.enum';

export class Amount {
  amount: number;
  currency: CurrencyEnum;
}
